import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class BraceletSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  splashNav(sku) {
    this.internalNav('jewelry/' + sku);
  }

	render() {
		return <div className='BraceletSplash'>
      <div className='bsTitle'>Bracelets</div>
      <div className='bsTop'>
        <div className='bsBox'>
          <div className='bsBoxTitle'>Trendy Bangles</div>
          <div className='bsBoxCopy'>This fashion-forward Tacori bangle features two sky-blue topaz ovals in an open-concept design.</div>
          <div className='bsBoxButtonWrapper'>
            <button className='bsBoxButton' onClick={() => this.splashNav('TACSS00087')}>Shop this Bracelet</button>
          </div>
        </div>
      </div>
      <div className='bsMid'>
        <div className='bsMidLeft'></div>
        <div className='bsMidRight'>
          <div className='bsMidImgWrapper'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/tennis.png' />
          </div>
          <div className='bsMidTitle'>Tennis Bracelets</div>
          <div className='bsMidCopy'>This bracelet provides ample sparkle on its own or can be stacked for a trendy look.</div>
          <div className='bsMidButtonWrapper'>
            <button className='bsBoxButton' onClick={() => this.splashNav('TB20000325')}>Shop this Bracelet</button>
          </div>
        </div>
      </div>
      <div className='bsBottom'>
        <div className='bsBottomLeft'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/pearls.png' />
          <button className={'bsBoxButton bsButtonBottomLeft'} onClick={() => this.splashNav('PRLMS00397')}>Shop this Bracelet</button>
        </div>
        <div className='bsBottomRight'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/bracelet/diamond.png' />
          <button className={'bsBoxButton bsButtonBottomRight'} onClick={() => this.splashNav('GBANG01774')}>Shop this Bracelet</button>
        </div>
      </div>
		</div>;
	}
}
export default BraceletSplash;

function mapStateToProps(state) {
  return {

  };
}

export const BraceletSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(BraceletSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/BraceletSplash.jsx